import {AbstractParameter} from "parameters/AbstractParameter.js";
import ParameterContext from 'effects/ParameterContext.js';
import {
    midiEffectOptions,
    midiConditionalOptions,
    effectOptions,
    initializeEffect,
    initializeMidiEffect
}  from 'components/effects/constants.js';


export default superclass => class extends superclass  {
    shadowEffects = [];

    initShadowEffects() {
        this.transposeParameter = new AbstractParameter(
            'transpose',
            this,
            () => [],
            {
                min: -32,
                max: 32,
                defaultValue: 0
            });
        this.transposeParameter.setStore(
            this.sequencerEngine.store);

        this.transposeParameter.setContext(new ParameterContext().forSubSequence(this.subSequence));
        //this.registerParameter(this.transposeParameter);

        this.shadowEffects = [
            initializeMidiEffect("Sparse", this._subSequence),
            initializeMidiEffect("Stats", this._subSequence),
            initializeMidiEffect("Note Display", this._subSequence),
        ];
        this.shadowEffects.forEach(e => e._subSequence = this._subSequence);
    }
}
